<template>
  <OareContentView>
    <v-row class="text-title-large font-weight-regular justify-center">
      <v-col cols="12" lg="10">
        <page-content pageName="home" />
      </v-col>
    </v-row>
  </OareContentView>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PageContent from '@/components/base/OarePageContent.vue';

export default defineComponent({
  components: {
    PageContent,
  },
  setup() {
    return {};
  },
});
</script>
